import comp from "./AssessmentLearningGoals";
export default comp;
